import DictApi from '../../../api/src/basic/api/DictApi'
// import ClazzStandardApi from "../../../api/src/course_standard/api/ClazzStandardApi";
const dictApi = new DictApi();
// const clazzStandardApi = new ClazzStandardApi()
const state = {
    editQueue: []
}

const mutations = {
    push(state, {type, clazzStandardId, knowledgeId, data}) {
        state.editQueue.push(data)
    },
}

const actions = {
    initEditQueue: async function ({commit, state}) {
        commit('')
    },

    getKnowledgeMap: ({commit, state},courseStandardId)=>{
        return new Promise((resolve, reject) => {
            clazzStandardApi.getKnowledgeMap(courseStandardId).then(res=>{
                resolve(res);
            });
        })
    }

}

export default {
    // namespaced: true,
    state,
    actions,
    mutations
}
